import React from "react";
import { Row, Col } from "reactstrap";
import { FormattedMessage } from "react-intl";

export default function APLPresenceColorInfo() {
  return (
    <Row className="ps-1">
      <Col className="mt-2" style={{ display: "flex" }}>
        <div
          className="me-3"
          style={{
            background: "#4ee474",
            fontSize: "smaller",
            color: "black",
            width: "10px",
            height: "22px",
            display: "inline-block",
          }}
        >
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </div>
        <FormattedMessage id="Present" />
      </Col>
      <Col className="mt-2" style={{ display: "flex" }}>
        <div
          className="me-3"
          style={{
            background: "#FF5733",
            fontSize: "smaller",
            color: "black",
            width: "10px",
            height: "22px",
            display: "inline-block",
          }}
        >
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </div>
        <span>
          <FormattedMessage id="Absent" />
        </span>
      </Col>
      <Col className="mt-2" style={{ display: "flex" }}>
        <div
          className="me-3"
          style={{
            background: "#e7e7e7",
            fontSize: "smaller",
            color: "black",
            width: "10px",
            height: "22px",
            display: "inline-block",
          }}
        >
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </div>
        <FormattedMessage id="NoCheckIn" />
      </Col>
    </Row>
  );
}
